import { VI } from './languages'

export const LS_KEY = 'app_alowallet_language'

export const getLanguageCodeFromLS = () => {
  try {
    const codeFromStorage = localStorage.getItem(LS_KEY)

    return codeFromStorage || VI.locale
  } catch {
    return VI.locale
  }
}
